import { render } from "./SalesInvoices.vue?vue&type=template&id=89b133e2&scoped=true"
import script from "./SalesInvoices.vue?vue&type=script&lang=js"
export * from "./SalesInvoices.vue?vue&type=script&lang=js"

import "./SalesInvoices.vue?vue&type=style&index=0&id=89b133e2&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89b133e2"]])

export default __exports__